module.exports = __webpack_public_path__ + "media/images/new-business-card-cbc6c450a0b08beae1865847606aede2.jpg";